import { useState, useEffect } from "react";
import { userApi } from "../Api/api";
import AuthContext from "./AuthContext";

function Context({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        userApi.getCurrentUser().then((response) => {
            setUser(response.data.user);
        }).catch((err) => {
            setUser(null)
            console.error(err.response.data.message);
        }).finally( () => { setLoading(false) });
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading, setUser, setLoading}}>
            { children }
        </AuthContext.Provider>
    )
}

export default Context;
